import { createSlice } from "@reduxjs/toolkit";

export const HealthProfileSlice = createSlice({
  name: "HealthProfile",
  initialState: {
    List: [],
    HealthScreeningList: [],
    HealthGorilaActive: "",
    HealthLoading: false,
  },
  reducers: {
    GetList: (state) => {
      state.HealthLoading = true;
    },
    SetGetList: (state, action) => {
      state.List = action.payload;
      state.HealthLoading = false;
    },

    GetHealthScreeningList: (state) => {
      state.HealthLoading = true;
    },
    SetHealthScreeningList: (state, action) => {
      state.HealthScreeningList = action.payload || [];
      state.HealthLoading = false;
    },
  },
});

export const {
  GetList,
  SetGetList,
  GetHealthScreeningList,
  SetHealthScreeningList,
} = HealthProfileSlice.actions;

export default HealthProfileSlice.reducer;
